import { safeGetItem } from "@/utils/storage";

function normalizePath(path = ""): string {
  const lowered = path.toLowerCase();
  if (lowered.length > 1 && lowered.endsWith("/")) {
    return lowered.slice(0, -1);
  }
  return lowered;
}

/** True when the app has a persisted login session (same key as router auth guard). */
export function hasAuthenticatedSession(): boolean {
  const userDataEncoded = safeGetItem("userData") || "";
  if (!userDataEncoded) {
    return false;
  }
  try {
    const userData = JSON.parse(atob(userDataEncoded) || "{}");
    return !!(userData && userData.email);
  } catch {
    return false;
  }
}

export function isPublicAuthPath(path = ""): boolean {
  const normalizedPath = normalizePath(path);

  return (
    normalizedPath === "/login" ||
    normalizedPath === "/th/login" ||
    normalizedPath === "/signup" ||
    normalizedPath === "/th/signup" ||
    normalizedPath === "/signup/verify" ||
    normalizedPath === "/account/verify" ||
    normalizedPath === "/signup/info" ||
    normalizedPath === "/signup/branding" ||
    normalizedPath === "/pincode"
  );
}

export function isInitialPublicAuthPath(path = ""): boolean {
  const normalizedPath = normalizePath(path);

  return (
    normalizedPath === "/login" ||
    normalizedPath === "/th/login" ||
    normalizedPath === "/signup" ||
    normalizedPath === "/th/signup"
  );
}

export { normalizePath };

/** Product workspace controls do not inherit the employer's candidate branding. */
export function isHiringProductPath(path = ""): boolean {
  const normalized = normalizePath(path).replace(/^\/(en|th)(?=\/)/, "");
  return /^\/(assessments|respondents|account|assessment-group-analytics|report)(?:\/|$)/.test(normalized)
    || /^\/assessment\/(create|edit)(?:\/|$)/.test(normalized)
    || /^\/guest\/assessments(?:\/|$)/.test(normalized);
}
